import { render, staticRenderFns } from "./affix.vue?vue&type=template&id=43ae72e3&scoped=true&"
import script from "./affix.vue?vue&type=script&lang=js&"
export * from "./affix.vue?vue&type=script&lang=js&"
import style0 from "./affix.vue?vue&type=style&index=0&id=43ae72e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ae72e3",
  null
  
)

export default component.exports